import type { AxiosError } from "axios"
import { useState } from "react"
import { toast } from "react-toastify"

import type { ApiResponse } from "@/types"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useFormErr<TError extends Record<string, any>>() {
  const [formErr, setFormErr] = useState<TError>({} as TError)

  function handleMutationErr(err: AxiosError<ApiResponse<TError>>) {
    if (err.response?.data) {
      setFormErr(err.response.data.data)
      toast.error(err.response.data.message)
    } else {
      toast.error(err.message)
    }
  }

  return { formErr, setFormErr, handleMutationErr }
}
